import { throttle, debounce } from 'theme';
import { isDesktop } from 'responsive';

/**
 * BecomingFixed Web Component
 * Makes an element become fixed when scrolling past his parent, useful when handling sticky bottom element on mobile
 *
 * Usage:
 * <becoming-fixed>
 *   <div data-become-fixed>
 *     <!-- Content to become fixed -->
 *   </div>
 * </becoming-fixed>
 */

if (!customElements.get('becoming-fixed')) {
  class BecomingFixed extends HTMLElement {
    constructor() {
      super();
      this.target = this.querySelector('[data-become-fixed]');
      this.headerStickyNav = document.querySelector('header .header-secondary-nav');
      this.headerStickyNavTop = null;
    }

    connectedCallback() {
      if (!this.target) return;
      this.initialSetup();
      this.handleSticky();
      const throttledScrollHandler = throttle(() => this.handleSticky(), 100);
      const debouncedResize = debounce(() => this.initialSetup(), 100);
      window.addEventListener('resize', debouncedResize);
      window.addEventListener('scroll', throttledScrollHandler);
    }

    initialSetup() {
      this.target = this.querySelector('[data-become-fixed]');
      this.headerStickyNavTop = this.headerStickyNav?.getBoundingClientRect()?.top;
      this.handleSticky();
    }

    handleSticky() {
      if (isDesktop()) return;
      if (!this.target) {
        this.target = this.querySelector('[data-become-fixed]');
      }
      const parentTargetRect = this.target?.parentElement?.getBoundingClientRect();
      this.target?.classList.toggle(
        'is-fixed',
        parentTargetRect?.top + parentTargetRect?.height < this.headerStickyNavTop - 8,
      );
    }
  }

  customElements.define('becoming-fixed', BecomingFixed);
}
